import { render, staticRenderFns } from "./VendorsTable.vue?vue&type=template&id=6def559c&scoped=true"
import script from "./VendorsTable.vue?vue&type=script&lang=ts"
export * from "./VendorsTable.vue?vue&type=script&lang=ts"
import style0 from "./VendorsTable.vue?vue&type=style&index=0&id=6def559c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def559c",
  null
  
)

export default component.exports